import script from "./SubscriberView.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscriberView.vue?vue&type=script&setup=true&lang=js"

import "./SubscriberView.vue?vue&type=style&index=0&id=45928a12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45928a12"]])

export default __exports__